/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const CompleteModifyRenewalRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.POLICY_RENEWAL_SUMMARY.route,
    loadChildren: () =>
      import('@pages/modify-renewal-summary/modify-renewal-summary.module').then(m => m.ModifyRenewalSummaryPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.ALARM_TYPE_RENEWAL.route,
    loadChildren: () =>
      import('@pages/renewal-data/alarm-type-renewal/alarm-type-renewal.module').then(
        m => m.AlarmTypeRenewalPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.VETI_POLICY_RENEWAL.route,
    loadChildren: () =>
      import('@pages/renewal-data/verti-policy-renewal/verti-policy-renewal.module').then(
        m => m.VertiPolicyRenewalPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.COVERAGES_RENEWAL.route,
    loadChildren: () =>
      import('@pages/policy-data/coverages-renewal/coverages-renewal.module').then(m => m.CoveragesRenewalPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.POLICY_HOLDER_RESIDENCE_RENEWAL.route,
    loadChildren: () =>
      import('@pages/renewal-data/policy-holder-residence-renewal/policy-holder-residence-renewal.module').then(
        m => m.PolicyHolderResidenceRenewalPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.POLICY_FORM_RENEWAL.route,
    loadChildren: () =>
      import('@pages/renewal-data/policy-form-renewal/policy-form-renewal.module').then(
        m => m.PolicyFormRenewalPageModule
      ),
    canActivate: [NavigationGuard],
  },
];
